import React from "react";
import { Box, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomFormTextInput from "components/inputs/CustomFormTextInput/CustomFormTextInput";
import { RHFMaybeFieldError, toFieldError } from "common/utils";
import FormShareRegistry from "./FormShareRegistry";

export default function CreateRegistryStepOne() {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Box display="flex" flexDirection="column" flex={1} minHeight={0} sx={{ overflow: "hidden" }}>
      <Grid container spacing={2} px={3} sx={{ flexShrink: 0 }} mt={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormTextInput
            name="name"
            label="Registry Name"
            required
            placeholder="Registry name"
            register={register}
            error={toFieldError(errors.name as RHFMaybeFieldError)}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <CustomFormTextInput
            name="description"
            label="Description"
            required
            placeholder="Description"
            register={register}
            error={toFieldError(errors.description as RHFMaybeFieldError)}
          />
        </Grid>
      </Grid>

      <Box display="flex" flex={1} mt={2} minHeight={0}>
        <FormShareRegistry />
      </Box>
    </Box>
  );
}